
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Loading, VendutoList, LoadingTemplateType } from "@/components";
import { Utente, FinderVenduto, GruppoVenduto, ItemDatiLookup } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import saveAs from 'file-saver';

@Component({
    components: {
        Loading,
        VendutoList
    },
})
export default class Venduto extends Vue {

    private stagione: string = '';
    private zona: string = '';
    private modello: string = '';

    get loading() { return store.state.loading; }

    get user() { return store.state.currentUsr; }

    get userIsAdmin() { return this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined; }

    get pageSize(): number { return store.state.ui.dimensionePaginaListe; }

    get page(): number { return store.state.uiVenduto.pagina; }
    set page(value: number) { this.caricaPaginaVenduto(value); }

    get pageCount(): number { return store.state.uiVenduto.totPagine; }
    get numTotVenduti(): number { return store.state.uiVenduto.totItems; }
    
    get venduto(): GruppoVenduto[] { return store.state.uiVenduto.items; }

    get canSearchVenduto(): boolean {
        return (!!this.idFornitore && !!this.stagione);
    }  
    get vendutoNumTotaleCapi(): number 
    { 
        var tot = 0;
        if(store.state.uiVenduto.items) {
            store.state.uiVenduto.items.forEach(v => {
                tot += v.capiOrdinati;
            });
        }
        return tot;
    }
    get vendutoNumTotaleModelli(): number 
    { 
        var tot = 0;
        if(store.state.uiVenduto.items) {
            return store.state.uiVenduto.items.length;
        }
        return tot;
    }

    get stagioni(): ItemDatiLookup[] { 
        var stagioni: ItemDatiLookup[] = [];

        if(store.state.datiLookup && store.state.datiLookup.stagioni) {
            stagioni = store.state.datiLookup.stagioni;
        }

        return stagioni;
    }
    get fornitori (): Utente[]  {
        return store.state.fornitori;
    }

    get fornitore (): Utente | undefined  {
        return store.state.fornitore;
    }

    set fornitore (fornitore: Utente | undefined) {
        store.commit(StoreMutations.SetFornitore, fornitore);
        if(fornitore) {
            this.idFornitore = fornitore.id;
            this.caricaPaginaVenduto(store.state.uiVenduto.pagina);
        } else {
            this.idFornitore = '';
            store.commit(StoreMutations.SetVenduto, []);
        }
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return  LoadingTemplateType.TwoLineAvatarList;
    }
    get csvButtonLoading(){
        return store.state.uiVenduto.csvButtonLoading;
    }
    private idFornitore: string = '';

    created(): void {
        
        if(this.userIsAdmin) {
            this.fornitore = undefined;
            store.dispatch(StoreActions.GetFornitori);
        }
        else {
            this.idFornitore = this.user.idFornitore;
            this.caricaPaginaVenduto(store.state.uiVenduto.pagina);
        }
    }

    private caricaPaginaVenduto(pagina: number): void {        
        if(this.idFornitore && this.stagione) {            
            const finder = new FinderVenduto(this.idFornitore, pagina);            
            if(this.stagione != undefined && this.stagione.trim().length > 0) {
                finder.idStagione = this.stagione.trim();
            }
            if(this.modello != undefined && this.modello.trim().length > 0) {
                finder.modelloOrigine = this.modello.trim();
            }
            if(this.zona != undefined && this.zona.trim().length > 0) {
                finder.zona = this.zona.trim();
            }
            store.dispatch(StoreActions.GetVenduto, finder);
        }
    }

    private async downloadCSVVenduto(){
        const finder = new FinderVenduto(this.idFornitore);
        if(this.stagione != undefined && this.stagione.trim().length > 0) {
            finder.idStagione = this.stagione.trim();
        }
        if(this.modello != undefined && this.modello.trim().length > 0) {
            finder.modelloOrigine = this.modello.trim();
        }
        if(this.zona != undefined && this.zona.trim().length > 0) {
            finder.zona = this.zona.trim();
        }
        let data = await store.dispatch(StoreActions.DownloadCSVVenduto, finder);
        if(data){                          
            saveAs(data, `dati_venduto_${this.idFornitore}_${this.stagione}.csv`);                    
        }
    }

    @Watch("$store.state.uiVenduto.fornitore")
    @Watch("stagione")
    onCambioFiltri() {
        if(!this.stagione)
            store.commit(StoreMutations.SetVenduto, []);
        this.caricaPaginaVenduto(store.state.uiVenduto.pagina);
    }
}

